import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// Language labels for navigation and buttons
const labels = {
  en: {
    features: "Features",
    pricing: "Pricing",
    testimonials: "Testimonials",
    login: "Login",
    startChatting: "Start Chatting",
  },
  ar: {
    features: "المميزات",
    pricing: "الأسعار",
    testimonials: "آراء العملاء",
    login: "تسجيل الدخول",
    startChatting: "ابدأ الدردشة",
  },
  // Add more languages here as needed
};

export default function LandingHeader(
  { lang,  setLang } = { lang: "en", setLang: () => {} } // Default values for props
) {
  const currentLabels = labels[lang] || labels.en;
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <>
      <header className="absolute top-0 left-0 w-full z-50 px-4  mx-auto">
        <div className="flex items-center justify-between h-20 md:h-24">
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#features" className="text-white/80  mx-3 hover:text-white transition-colors" onClick={e => { e.preventDefault(); document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' }); }}>{currentLabels.features}</a>
            <a href="#pricing" className="text-white/80 mx-1 hover:text-white transition-colors" onClick={e => { e.preventDefault(); document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' }); }}>{currentLabels.pricing}</a>
            <a href="#testimonials" className="text-white/80  hover:text-white transition-colors" onClick={e => { e.preventDefault(); document.getElementById('testimonials')?.scrollIntoView({ behavior: 'smooth' }); }}>{currentLabels.testimonials}</a>
             <div className="">
              <button
                className={`text-white/80 hover:text-white transition-colors text-xs md:text-sm px-2 py-1 rounded ${lang === 'en' ? 'bg-[#0E91A5] text-white' : ''}`}
                onClick={() => setLang('en')}
                disabled={lang === 'en'}
              >
                EN
              </button>
              <button
                className={`text-white/80 hover:text-white transition-colors text-xs md:text-sm px-2 py-1 rounded ${lang === 'ar' ? 'bg-[#0E91A5] text-white' : ''}`}
                onClick={() => setLang('ar')}
                disabled={lang === 'ar'}
              >
                AR
              </button>
              {/* Add more language buttons here if needed */}
            </div>
          </nav>
     
          <Link 
          className={'flex items-center ' +    (lang === 'ar' ? 'ml-0 sm:ml-16 ' : '')
         
          }
          to="/">
            <img src="/3.png" alt="Logo" className="w-48 h-auto"></img>
          </Link>
          <div className="hidden md:flex items-center space-x-2 md:space-x-4">
            {/* Language Switcher */}
           
            <Link to="/auth/login" className="text-white/80 hover:text-white transition-colors mx-5 text-sm md:text-base">{currentLabels.login}</Link>
            <Link to="/auth/register" className="font-semibold shadow-md">
              <div className="p-[1.5px] md:p-[2px] rounded-[8px] md:rounded-[10px] bg-gradient-to-r from-[#D7FAFF] to-[#0E91A5]">
                <div className="flex items-center space-x-1 md:space-x-2 bg-[#041B29] rounded-[7px] md:rounded-[8px] px-3 py-1.5 md:px-5 md:py-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                    <circle cx="5" cy="5" r="4" fill="#12B76A"></circle>
                  </svg>
                  <span className="text-xs px-2 md:text-base">{currentLabels.startChatting}</span>
                </div>
              </div>
            </Link>
          </div>
          {/* Mobile menu button */}
          <button
            className="md:hidden text-white ml-2"
            onClick={() => setMobileMenuOpen((open) => !open)}
            aria-label="Open menu"
          >
            <svg width="24" height="24" fill="none" stroke="currentColor">
              <path d="M4 6h16M4 12h16M4 18h16"/>
            </svg>
          </button>
        </div>
        {/* Mobile menu dropdown */}
        {mobileMenuOpen && (
          <nav className="md:hidden bg-[#041B29] px-0 py-2 rounded-b-lg shadow-lg absolute top-full left-0 w-full z-50">
            <a href="#features" className="block py-2 px-4 text-white/80 hover:text-white transition-colors">{currentLabels.features}</a>
            <a href="#pricing" className="block py-2 px-4 text-white/80 hover:text-white transition-colors">{currentLabels.pricing}</a>
            <a href="#testimonials" className="block py-2 px-4 text-white/80 hover:text-white transition-colors">{currentLabels.testimonials}</a>
            <div className="flex items-center space-x-2 mt-2 px-4">
              <button
                className={`text-white/80 hover:text-white transition-colors text-xs px-2 py-1 rounded ${lang === 'en' ? 'bg-[#0E91A5] text-white' : ''}`}
                onClick={() => setLang('en')}
                disabled={lang === 'en'}
              >
                EN
              </button>
              <button
                className={`text-white/80 hover:text-white transition-colors text-xs px-2 py-1 rounded ${lang === 'ar' ? 'bg-[#0E91A5] text-white' : ''}`}
                onClick={() => setLang('ar')}
                disabled={lang === 'ar'}
              >
                AR
              </button>
            </div>
            <Link to="/auth/login" className="block py-2 px-4 text-white/80 hover:text-white transition-colors">{currentLabels.login}</Link>
            <Link to="/auth/register" className="block py-2 px-4 font-semibold text-white bg-gradient-to-r from-[#D7FAFF] to-[#0E91A5] rounded mt-2 text-center">{currentLabels.startChatting}</Link>
          </nav>
        )}
      </header>
    </>
  );
}
